import Vue from 'vue'

Vue.directive('pml-focus', {
    inserted (el) {
        el.focus()
    }
})

Vue.directive('pml-autocomplete-tag-input-focus', {
    inserted (el) {
        el.getElementsByClassName('new-tag-input')[0].focus()
    }
})



// WEBPACK FOOTER //
// ./src/utils/directives/focus.js